export enum Envs {Local, Dev, Demo, Staging, Production}
